module.exports = {"pathContext":{"slug":"/es/suggestions/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es-suggestions.json
// module id = 1232
// module chunks = 269473319772990